import React, { Children, cloneElement } from 'react'
// libs
import styled from 'styled-components'
// constants
import { reactVirtualizedClassName } from 'components/Modals/ScaleFormModal/components/Form/index'

// styled
const ChildrenWrapper = styled.div`
  height: 100%;
`

const Wrapper = styled.div`
  padding: 5px 0;
`

export const ScaleModalTreeNodeRendererContext = React.createContext({})

const TreeNodeRenderer = (props) => {
  const {
    canDrop,
    children,
    connectDropTarget,
    draggedNode,
    getPrevRow, // Delete from otherProps
    isOver,
    listIndex,
    lowerSiblingCounts,
    node, // Delete from otherProps
    path, // Delete from otherProps
    rowDirection,
    scaffoldBlockPxWidth,
    swapDepth,
    swapFrom,
    swapLength,
    treeId,
    treeIndex,
    ...otherProps
  } = props

  // Construct the scaffold representing the structure of the tree
  const scaffoldBlockCount = lowerSiblingCounts.length - 1
  // let dropType
  //
  // if (canDrop && !isOver) {
  //   dropType = 'validDrop'
  // } else {
  //   if (!canDrop && isOver) {
  //     dropType = 'invalidDrop'
  //   }
  // }

  // state
  const [isDragStarted, setIsDragStarted] = React.useState(false)

  const element = document.querySelector(`.${reactVirtualizedClassName}`)

  element.addEventListener('dragstart', () => setIsDragStarted(true))
  element.addEventListener('dragend', () => setIsDragStarted(false))

  const value = { isDragStarted }

  return (
    <ScaleModalTreeNodeRendererContext.Provider value={value}>
      <Wrapper {...otherProps} ref={connectDropTarget}>
        <ChildrenWrapper style={{ paddingLeft: scaffoldBlockPxWidth * scaffoldBlockCount }}>
          {Children.map(children, (child) =>
            cloneElement(child, {
              isOver,
              canDrop,
              draggedNode
            })
          )}
        </ChildrenWrapper>
      </Wrapper>
    </ScaleModalTreeNodeRendererContext.Provider>
  )
}

TreeNodeRenderer.defaultProps = {
  swapFrom: null,
  swapDepth: null,
  swapLength: null,
  canDrop: false,
  draggedNode: null,
  rowDirection: 'ltr'
}

// TreeNodeRenderer.propTypes = {
//   treeIndex: number.isRequired,
//   swapFrom: number,
//   swapDepth: number,
//   swapLength: number,
//   scaffoldBlockPxWidth: number.isRequired,
//   lowerSiblingCounts: arrayOf(number).isRequired,
//   treeId: string.isRequired,
//   listIndex: number.isRequired,
//   rowDirection: string,
//   children: node.isRequired,
//
//   // Drop target
//   connectDropTarget: func.isRequired,
//   isOver: bool.isRequired,
//   canDrop: bool,
//   draggedNode: shape({}),
//
//   // used in dndManager
//   getPrevRow: func.isRequired,
//   node: shape({}).isRequired,
//   path: arrayOf(oneOfType([string, number])).isRequired
// }

export default TreeNodeRenderer
